import {Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective implements OnDestroy {
  @Input() tooltipText: string;
  @Input() position: string;
  @Input() customClass = '';
  @Input() template: TemplateRef<any>;
  @Input() context: any;
  @Input() isFixed = false;

  private tooltip: HTMLElement;
  private longTextTooltip: boolean;
  private offset = 8;

  constructor(private el: ElementRef, private renderer: Renderer2, private viewContainerRef: ViewContainerRef) {}

  ngOnDestroy(): void {
    this.hide();
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip) {
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) {
      this.hide();
    }
  }

  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  hide() {
    if (this.tooltip) {
      this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }

  create() {
    let tooltipContent;
    this.tooltip = this.renderer.createElement('span');

    if (this.tooltipText) {
      tooltipContent = this.renderer.createText(this.tooltipText);
    }

    if (this.template) {
      const ref = this.viewContainerRef.createEmbeddedView(this.template, this.context);
      tooltipContent = ref.rootNodes[0];
      ref.detectChanges();
      tooltipContent.remove();
    }

    this.renderer.appendChild(this.tooltip, tooltipContent);

    this.renderer.appendChild(document.body, this.tooltip);

    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    this.renderer.addClass(this.tooltip, `ng-tooltip-${this.position}`);
    if (this.customClass) {
      this.renderer.addClass(this.tooltip, this.customClass);
    }

    if (this.tooltip.offsetWidth === 305) {
      this.longTextTooltip = true;
      this.renderer.addClass(this.tooltip, 'long-text-tooltip');
    }
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip.getBoundingClientRect();

    const scrollPos = this.isFixed ? 0 : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    let top;
    let left;

    if (this.position === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.position === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.position === 'left') {
      top = this.longTextTooltip ? hostPos.top - hostPos.height : hostPos.top - hostPos.height + this.offset;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.position === 'right') {
      top = this.longTextTooltip ? hostPos.top - hostPos.height : hostPos.top - hostPos.height + this.offset;
      left = hostPos.right + this.offset;
    }

    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
